import { render, staticRenderFns } from "./SuppliersFormPage.vue?vue&type=template&id=70b5dbc2&"
import script from "./SuppliersFormPage.vue?vue&type=script&lang=js&"
export * from "./SuppliersFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports